import { LINKS } from "@/constants/links";

export default function Prenota() {
  return (
    <section id="prenota" className="py-24 px-6 bg-[#121110]" data-testid="prenota-section">
      <div className="max-w-4xl mx-auto text-center border border-[#2a2825] p-8 md:p-16 bg-[#181614]">
        <span className="font-mono-tag text-xs uppercase tracking-widest text-[#c9944a]">Prenotazioni &amp; Disponibilità</span>
        <h2 className="text-3xl md:text-5xl font-display mt-4 mb-6">Pianifica il tuo soggiorno a Marino</h2>
        <p className="text-sm md:text-base text-[#a8a095] max-w-xl mx-auto mb-10 leading-relaxed">
          Contattaci direttamente su WhatsApp per informazioni e offerte riservate, o prenota tramite i principali portali.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a href={LINKS.whatsapp} target="_blank" rel="noopener noreferrer" data-testid="cta-whatsapp" className="w-full sm:w-auto px-8 py-4 bg-[#c9944a] text-[#121110] font-semibold text-xs uppercase tracking-widest font-mono-tag hover:bg-[#d8a55b] transition-colors">
            Scrivici su WhatsApp
          </a>
          <a href={LINKS.airbnb} target="_blank" rel="noopener noreferrer" data-testid="cta-airbnb" className="w-full sm:w-auto px-8 py-4 border border-[#3e3a35] text-[#f4efe8] font-semibold text-xs uppercase tracking-widest font-mono-tag hover:border-[#c9944a] transition-colors">
            Visualizza su Airbnb
          </a>
          <a href={LINKS.booking} target="_blank" rel="noopener noreferrer" data-testid="cta-booking" className="w-full sm:w-auto px-8 py-4 border border-[#3e3a35] text-[#f4efe8] font-semibold text-xs uppercase tracking-widest font-mono-tag hover:border-[#c9944a] transition-colors">
            Visualizza su Booking
          </a>
        </div>

        <div className="mt-12 pt-8 border-t border-[#2a2825] text-xs text-[#a8a095]">
          <p>Recensioni e valutazioni dei primi ospiti in arrivo sulle piattaforme dedicate.</p>
        </div>
      </div>
    </section>
  );
}
